import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-notifications-page',
	templateUrl: './notifications-page.component.html',
	styleUrls: ['./notifications-page.component.css']
})
export class NotificationsPageComponent implements OnInit {

	constructor () { }

	ngOnInit(): void {
	}
}
